import { motion } from "framer-motion";
import HeroImg from "./HeroImg.png"
import { useNavigate } from "react-router-dom";

interface PageProps {
    setView: (view: string) => void
}

export function DownloadPage() {
    const navigate = useNavigate();
    return (
        <div className="mainsection">
            <div className="downloadsZone">
                <h1>Downloads</h1>
                <button
                    style={{ width: "120px", height: "60px" }}
                    onClick={() => navigate("/")} // Navigate back to root
                > Go Back</button>
            </div>
            <h3>We Provide a Free Version which can be use as a starting point for your events</h3>
            <div className="DownloadsSection">
                <div className="Card1">
                    <div><motion.button whileHover={{scale: 1.2}} className="Download-Button Windows" onClick={() => window.open("https://drive.google.com/drive/folders/169cMDTs0HU0CLdGNCjE4S2uWG5n7o1Xv?usp=sharing", "_blank")}>Windows</motion.button></div>
                    <div><motion.button whileHover={{scale: 1.2}} className="Download-Button Linux" onClick={()=>window.open("https://drive.google.com/drive/folders/1yr7WdZV7aT9-TQrbeCsU6d-y23QvA4kl?usp=drive_link", "_blank")}>Linux</motion.button></div>
                    <div><motion.button whileHover={{scale: 1.2}} className="Download-Button MacOS" onClick={()=>window.open("https://drive.google.com/drive/folders/1BfoeZFsbDtgQOJ2WHdkM6vck-xOKYCJG?usp=drive_link", "_blank")}>MacOS</motion.button></div>
                </div>
            </div>
            <h3>Requirements</h3>
            <div className="IntroPageDesc">
                <div className="features-section">
                    <div className="Card0">
                        <h3>Hardware</h3>
                        <div>OS:<br />* Windows 10/11<br />* MacOS ARM<br />* Ubuntu 22.04</div>
                    </div>
                    <div className="Card0">
                        <h3>Software</h3>
                        <div>1-2GB RAM <br/> 100MB Storage for applications <br/> 1 - 10GB of storages for photos saved on your device <br/>Tested Currently on EPSON L3210</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function HomePage() {
    const navigate = useNavigate();
    return (
        <div>
            <div className="hero-section">
                <div className="herosection2">
                    <div className="herosection3">
                        <div className="IntroPageDesc">
                            <motion.div initial={{ opacity: 0, x: -250 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
                                <h1>Click, Shot and Enjoy the moments</h1>
                                <div className="MainButton">
                                    <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}
                                        className="Button0 btn-download"
                                        onClick={() => navigate("/downloads")}
                                    >Download Now</motion.button>

                                    <motion.button whileTap={{ scale: 0.95 }} whileHover={{ scale: 1.1 }}
                                        className="Button0 btn-try"
                                        onClick={() => window.location.href = "https://photoracca-v2.netlify.app/"}
                                    >Try for Free</motion.button>

                                    <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}
                                        className="Button0 btn-buy"
                                        onClick={() => navigate("/purchase")}
                                    >Buy Now</motion.button>

                                    <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}
                                        className="Button0 btn-book"
                                        onClick={() => navigate("/contact")}
                                    >Book Us Now</motion.button>
                                </div>
                            </motion.div>
                        </div>
                        <motion.div initial={{ opacity: 0, x: 250 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
                            <img className="HeroImg0" src={HeroImg} alt="Hero"></img>
                        </motion.div>
                    </div>
                </div>
            </div>

            <div className="mainsection">
                <h1>Features</h1>
                <div className="features-section">
                    <div className="Card0">
                        <div>
                            <h3>Snap with friends</h3>
                        </div>
                        <div>Snap with the moments with friends or yourself, with family or even with your relationship</div>
                    </div>
                    <div className="Card0">
                        <div>
                            <h3>Customize With Stickers</h3>
                        </div>
                        <div>Create Fun and exitement with hundreds of stickers which could make with fun with</div>
                    </div>
                    <div className="Card0">
                        <div>
                            <h3>Share with friends(Work In Progress)</h3>
                        </div>
                        <div>Save the image in digital format for a limited time, we still working on it <br /> We Respect your privacy where allowing to save the image for 1 day only and it will be deleted after 1 day</div>
                    </div>
                    <div className="Card0">
                        <div>
                            <h3>Great for Parties, Birthdays and Events</h3>
                        </div>
                        <div>Our Photobooth was good for events wether social days, excitement and more even to any kind of events wether school days, birthdays and more</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function PurchasePage() {
    const navigate = useNavigate();
    return (
        <div className="hero-section">
            <div className="purchase-container">
                <h1>Select your Plan</h1>
                <p>Choose the best package for your events.</p>
                <button onClick={() => navigate("/")}>Back to Home</button>
            </div>
        </div>
    );
}

export function ContactPage() {
    const navigate = useNavigate();
    return (
        <div className="hero-section">
            <div className="purchase-container">
                <h1>Select your Plan</h1>
                <p>Choose the best package for your events.</p>
                <button onClick={() => navigate("/")}>Back to Home</button>
            </div>
        </div>
    );
}